export const safeArrayLength = (n: number | undefined): number =>
  Number.isFinite(n) ? Math.max(0, Math.floor(n as number)) : 0;

export const repeatByCount = <T extends { count?: number }>(items: T[]): T[] =>
  items.flatMap((item) =>
    Array.from({ length: safeArrayLength(item.count) }, () => item)
  );
